import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  mainWrapper: { width: '100%' },
  title: {
    color: '#003353',
    fontSize: 32,
    fontWeight: '600',
    lineHeight: 48,
  },
  subtitle: {
    color: '#003353',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
  },
  backBtnContainer: { flexDirection: 'row', alignItems: 'center' },
  backBtnText: {
    fontWeight: '600',
    color: '#335C75',
    fontSize: 16,
    marginLeft: 15,
  },
  backBtnTextTitle: {
    marginTop: 20,
    color: '#003353',
    fontSize: 32,
    fontWeight: '600',
  },
  projectViewDetailBtnText: {
    marginTop: 10,
    color: '#00A0F3',
    fontSize: 16,
    fontWeight: '600',
  },
  projectTileContainer: {
    marginTop: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  projectCustomerIconSize: {
    width: 19,
    height: 19,
  },
  addProjectBtn: {
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 220,
    maxHeight: 48,
    position: 'absolute',
    right: 36,
    top: 12,
  },
  addButtonLabel: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    marginRight: 24,
  },
  projectTabsTitleText: {
    color: '#003353',
    fontSize: 20,
    fontWeight: '600',
    marginTop: 32,
    marginBottom: 16,
  },
  mt24: {
    marginTop: 24,
  },
  projectTabLabel: { paddingBottom: 20, fontSize: 24 },
})
